export default __webpack_public_path__ + "static/media/m-learning.3c644437.svg";